import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"color":_vm.snackbar.color,"timeout":_vm.snackbar.timeout},model:{value:(_vm.snackbar.ativo),callback:function ($$v) {_vm.$set(_vm.snackbar, "ativo", $$v)},expression:"snackbar.ativo"}},[_vm._v("\n  "+_vm._s(_vm.snackbar.mensagem)+"\n  "),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.desabilitaSnackbar}},[_vm._v("Fechar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }